<template>
  <div class="vip-user-info-component">
    <ym-avatar class="vip-user-info-avatar"
            size="medium"
            :avatar="avatar"
            :name="name"
    />
    <div class="vip-user-info-desc">
      <div class="vip-user-info-title">
        <div class="vip-user-info-name">{{ name }}</div>
        <ym-img v-if="showIcon"
                class="vip-user-info-icon"
                :src="require(`@/assets/img/vip/${iconName}.png`)"
                alt="VIP 图标"
        />
      </div>
      <div class="vip-user-info-slot">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'VipUserInfo',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      type: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            '',
            'normal',
            'experience',
          ].includes(val);
        },
        required: true,
      },
      avatar: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      status: String,
    },
    computed: {
      showIcon() {
        const { type } = this;
        return type !== '';
      },
      iconName() {
        const { status = 'effective', type } = this;
        return `${type}_my_vip_icon__${status}`;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-user-info {
    &-component {
      box-sizing: border-box;
      display: flex;
      align-items: stretch;
      background: @gradient-gold;
    }

    &-desc {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px 0 10px;
      line-height: 1.1;
    }

    &-avatar {
      margin-right: @size-small;
    }

    &-title {
      display: flex;
      align-items: flex-end;
      font-size: @font-size-large;
    }

    &-icon {
      height: 24px;
      margin: 0 0 2px @size-extra-small;

      /deep/ .ym-image-img {
        width: auto;
      }
    }

    &-slot {
      font-size: @font-size-extra-small;
    }
  }
</style>
